import { computed, inject, Injectable } from '@angular/core';
import {
  INichoTermos,
  NICHO_TERMOS_MULTILANG_MAP,
  NICHO_TERMOS_MAP,
  NichoEstabelecimentoEnum,
} from '@nomoh-monorepo/shared-types';
import { I18nService } from '@nomoh-monorepo/data-access-shared-i18n';
import { EstabelecimentoDataService } from './estabelecimento.dataservice';

@Injectable({
  providedIn: 'root',
})
export class NichoTermosService {
  private estabDataService = inject(EstabelecimentoDataService);
  private i18nService = inject(I18nService);

  /**
   * Signal computado que reativamente calcula todos os termos e placeholders
   * para a interface do Bardo com base no nicho do estabelecimento atual
   * e no idioma ativo no sistema.
   */
  $nicho = computed<INichoTermos>(() => {
    const estab = this.estabDataService.$estabelecimentoAtual();
    const nichoKey = (estab?.nicho as NichoEstabelecimentoEnum) || NichoEstabelecimentoEnum.BELEZA_ESTETICA;
    const langCode = this.i18nService.idioma().code || 'pt';

    const mapaIdioma =
      NICHO_TERMOS_MULTILANG_MAP[langCode] ||
      NICHO_TERMOS_MULTILANG_MAP['pt'] ||
      NICHO_TERMOS_MAP;

    return mapaIdioma[nichoKey] || mapaIdioma[NichoEstabelecimentoEnum.BELEZA_ESTETICA];
  });

  /** Alias para compatibilidade */
  $termos = this.$nicho;
}

